(function () {
  'use strict';
  var API = 'https://thepiecraft-rugs.vercel.app/api/market-config';
  var current = (window.ShopifyMarket && window.ShopifyMarket.country) || 'IN';
  var names = { IN:'India', US:'United States', GB:'United Kingdom', AE:'UAE', AU:'Australia', CA:'Canada', SG:'Singapore', DE:'Germany', FR:'France', NL:'Netherlands' };

  function indicator(code) {
    var el = document.getElementById('piecraft-market-indicator');
    if (!el) {
      el = document.createElement('button');
      el.id = 'piecraft-market-indicator'; el.type = 'button';
      el.setAttribute('aria-label', 'Change delivery country');
      el.style.cssText = 'position:fixed;left:12px;bottom:12px;z-index:40;border:1px solid rgba(72,54,40,.2);border-radius:999px;background:#fffaf4;color:#3f3026;padding:8px 12px;font:600 12px/1.2 system-ui;box-shadow:0 5px 18px rgba(55,39,25,.12);cursor:pointer';
      el.addEventListener('click', function () { var selector = document.querySelector('localization-form-component summary, .localization-form button, [data-country-selector]'); if (selector) selector.click(); });
      document.body.appendChild(el);
    }
    el.textContent = 'Shipping to ' + (names[code] || code);
  }

  function localize(code) {
    if (!code || code === current || sessionStorage.getItem('piecraft-market-routed') === code) return;
    // POST /localization returns 404 on this store, so go to the market's own URL for this page
    // (Shopify lists it in the hreflang alternates). No alternate means no redirect, never an error page.
    var alt = document.querySelector('link[rel="alternate"][hreflang="en-' + code + '"]');
    if (!alt || !alt.href) return;
    var target = new URL(alt.href, location.href);
    if (target.pathname === location.pathname) return;
    sessionStorage.setItem('piecraft-market-routed', code);
    location.replace(target.pathname + location.search + location.hash);
  }

  indicator(current);
  fetch(API, { credentials:'omit', mode:'cors', headers:{Accept:'application/json'} }).then(function(r){ if(!r.ok) throw new Error('market lookup failed'); return r.json(); }).then(function(m){
    if (m && m.countryCode === m.detectedCountry) { indicator(m.countryCode); localize(m.countryCode); }
  }).catch(function(){ /* Keep Shopify's current market if geolocation is unavailable. */ });
})();
